// extracted by mini-css-extract-plugin
export default {"file":"ImageItem_file__bYRAc","fileTextInf":"ImageItem_fileTextInf__0eMqI","fileInf":"ImageItem_fileInf__T1-oz","fileName":"ImageItem_fileName__Eut5m"};